var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFarmLand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 79,
    viewBox: "0 0 67 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6946 64.9581C55.6767 61.3261 66 48.6186 66 33.5C66 15.5507 51.4493 1 33.5 1C15.5507 1 1 15.5507 1 33.5C1 48.1716 10.7218 60.5725 24.0749 64.6123L33 78L41.6946 64.9581Z",
    fill: "#00C781"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6946 64.9581L41.5689 64.4742L41.3843 64.5221L41.2786 64.6808L41.6946 64.9581ZM24.0749 64.6123L24.4909 64.3349L24.3914 64.1857L24.2197 64.1337L24.0749 64.6123ZM33 78L32.584 78.2774L33 78.9014L33.416 78.2774L33 78ZM65.5 33.5C65.5 48.3853 55.336 60.898 41.5689 64.4742L41.8203 65.4421C56.0174 61.7542 66.5 48.8519 66.5 33.5H65.5ZM33.5 1.5C51.1731 1.5 65.5 15.8269 65.5 33.5H66.5C66.5 15.2746 51.7254 0.5 33.5 0.5V1.5ZM1.5 33.5C1.5 15.8269 15.8269 1.5 33.5 1.5V0.5C15.2746 0.5 0.5 15.2746 0.5 33.5H1.5ZM24.2197 64.1337C11.0716 60.156 1.5 47.9451 1.5 33.5H0.5C0.5 48.398 10.372 60.9891 23.9301 65.0909L24.2197 64.1337ZM33.416 77.7226L24.4909 64.3349L23.6588 64.8896L32.584 78.2774L33.416 77.7226ZM41.2786 64.6808L32.584 77.7226L33.416 78.2774L42.1106 65.2355L41.2786 64.6808Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_892_13760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.2362 49.5868H9.68164L13.9565 36.8223H53.9614L58.2362 49.5868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9565 36.8223L9.68164 49.5868",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.673 36.8223L16.6191 49.5868",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3864 36.8223L23.5547 49.5868",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.103 36.8223L30.4922 49.5868",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8164 36.8223L37.4272 49.5868",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5312 36.8223L44.3636 49.5868",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2461 36.8223L51.3 49.5868",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9609 36.8223L58.2358 49.5868",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8144 32.7313C18.4443 32.7313 19.7656 29.9141 19.7656 26.4389C19.7656 22.9637 18.4443 20.1465 16.8144 20.1465C15.1846 20.1465 13.8633 22.9637 13.8633 26.4389C13.8633 29.9141 15.1846 32.7313 16.8144 32.7313Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8145 24.2891V36.7877",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2441 32.7313C29.874 32.7313 31.1953 29.9141 31.1953 26.4389C31.1953 22.9637 29.874 20.1465 28.2441 20.1465C26.6143 20.1465 25.293 22.9637 25.293 26.4389C25.293 29.9141 26.6143 32.7313 28.2441 32.7313Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2441 24.2891V36.7877",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6738 32.7313C41.3037 32.7313 42.625 29.9141 42.625 26.4389C42.625 22.9637 41.3037 20.1465 39.6738 20.1465C38.0439 20.1465 36.7227 22.9637 36.7227 26.4389C36.7227 29.9141 38.0439 32.7313 39.6738 32.7313Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6738 24.2891V36.7877",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1035 32.7313C52.7334 32.7313 54.0547 29.9141 54.0547 26.4389C54.0547 22.9637 52.7334 20.1465 51.1035 20.1465C49.4736 20.1465 48.1523 22.9637 48.1523 26.4389C48.1523 29.9141 49.4736 32.7313 51.1035 32.7313Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1035 24.2891V36.7877",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_892_13760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.083,
    height: 30.9686,
    fill: "white",
    transform: "translate(8.91797 19.3828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmLand);
export default __webpack_public_path__ + "static/media/farm-land.0701e0512a0035303fa75a0eba9ad5cf.svg";
export { ForwardRef as ReactComponent };